import React from "react";
import Styles from "../styles.module.scss";
import Button from "../../Button";
import { OrderTypeTextsENUM } from "../VenueOrderTypes";
import T from "i18n-react";

interface IInfoArray {
  key: string;
  value: string;
}

interface IOrderTypeProps {
  infoArray: IInfoArray[];
  buttonText: string;
  handleButtonClick: () => void;
  noMinValue?: boolean;
  selected?: boolean;
}

function OrderType({
  infoArray,
  buttonText,
  handleButtonClick,
  noMinValue,
  selected,
}: IOrderTypeProps) {
  function renderFlexBoxs(infoArray: IInfoArray[]) {
    return infoArray
      .filter((info) =>
        noMinValue
          ? info.key !== OrderTypeTextsENUM.MinOrderValue
          : info.value === "null"
          ? false
          : true
      )
      .map((item, i) => {
        return (
          <div key={`${i}`} className={Styles.OrderTypeInfo}>
            <p>{T.translate(item.key)}</p>
            <p>{item.value}</p>
          </div>
        );
      });
  }
  return (
    <div>
      {renderFlexBoxs(infoArray)}
      <Button
        dataComponentName={selected ? "VenuePageOrderTypesViewMenuButton" : ""}
        className={Styles.ViewMenuButton}
        title={buttonText}
        onClick={handleButtonClick}
        isYoelloBtn
      />
    </div>
  );
}

export default OrderType;
